import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "./../../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "./../../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addBagmaster.html",
})
export class addBagmaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  ItemList : any = [];
  nameList = ["1","2" ,"3","4","5","6","7","8"];

  codeList: any;
  seasonList: any;

  execApi: boolean = true;
  //  isEdit: boolean = false;
  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];

  mode: string;
  saveEvent: any;
  agentList: any;
  uniqueTypeList: any;
  prefixList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  isShow : boolean = false;

  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  varietyList = ["CHECKS","PLAIN"];
  widthList = ["36", "44", "58"];
  styleList = ["FORMAL", "CASUAL"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  res = []
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  qualitylist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
  
   this.saveEvent = val["data"].tabevent;
    this.getSetDetails();
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
    this.row = {
      width: "",
      size: "",
      sleeve: "",
      type: "",
      
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {

//   this.data.invoiceList = [
//   { series: 1, prefix: 'B3', formal: 3, casual: 0, barcode: 'B3-1' },
//   { series: 2, prefix: 'B3', formal: 3, casual: 0, barcode: 'B3-2' },
//   { series: 3, prefix: 'B3', formal: 3, casual: 0, barcode: 'B3-3' },
//   { series: 4, prefix: 'B3', formal: 3, casual: 0, barcode: 'B3-4' },
//   { series: 5, prefix: 'B3', formal: 3, casual: 0, barcode: 'B3-5' }, 
//   { series: 1, prefix: 'S4', formal: 4, casual: 0, barcode: 'S4-1' },
//   { series: 2, prefix: 'S4', formal: 4, casual: 0, barcode: 'S4-2' }, 
//   { series: 1, prefix: 'C4F5', formal: 5, casual: 4, barcode: 'C4F5-1'}
// ];
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  OnselectpartyId(type){
   let temp = this.partyList.filter(el=>el.code == type);
   this.invoicedata.party_id = temp[0].party_id;


  }
  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "90%" : "73% !important",
      bottom: "54px"
    };
    return style;
  }

 addPlainDetails() {


  const from = Number(this.invoicedata.from_range);
  const to = Number(this.invoicedata.to_range);
  this.data.invoiceList = [];
  if (isNaN(from) || isNaN(to) || from > to) {
      swal(`ERROR`, `Invalid Range`, `error` );
    return;
  }

  // const startSeries = this.invoicedata.series;
  const item = this.invoicedata.item;
  const formal = Number(this.invoicedata.formal) || 0;
  const casual = Number(this.invoicedata.casual) || 0;

  if (!item || !this.invoicedata.barcode || !from) {
   swal(`ERROR`, `Invalid Range`, `error` );
    return;
  }

  // Extract prefix from existing barcode
  const prefix = this.invoicedata.prefix

  // Push objects based on range
   
  for (let i = 0; i <= (to - from); i++) {
    const series = from + i;
    const newEntry = {
       item,
      formal,
      casual,
      series,
      barcode: `${prefix}-${series}`
    };
    this.data.invoiceList.push(newEntry);
  }
  this.isShow = true ;
 
}

  onEnterKeyPressed(nextEl: string) {

    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }

  }



  calcRange() {
  if (!this.invoicedata.prefix){
    swal(`ERROR`, `Please Enter Prefix!`, `error` );
    return;
  } 
    let params = {
      page_type: 'Bag',
      prefix: this.invoicedata.prefix   
    }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      let List = res.data;
      // Determine next series number
      if (List.length > 0) {
        const maxSeries = Math.max(...List.map(entry => entry.series));
        this.invoicedata.from_range = maxSeries + 1;
      } else {
        this.invoicedata.from_range = 1;
      }

      // Set barcode using determined prefix and series
      this.invoicedata.barcode = `${this.invoicedata.prefix}-${this.invoicedata.from_range}`;

    })

  }



 
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  getEditMode(ind) {
      
    this.data.invoiceList[ind].isEdit = !this.data.invoiceList[ind].isEdit;
  }

  EditDet() {

    let that = this;
    swal({
      title: "Are you sure to Clear the TableGrid?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Edit it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {
          
          that.data.invoiceList = [];

      
        }
      },
      function (dismiss) { }
    );
  }
  getSetDetails() {
 let params = {
  page_type : 'Item Type'
 }
    this.salesinvservice.getSetDetails(params).then((res: any) => {

      this.ItemList = res.data;
   

   this.uniqueTypeList = this.ItemList.reduce((acc, curr) => {
    if (!acc.includes(curr.item_type)) {
        acc.push(curr.item_type);
    }
    return acc;
}, []);

});
  }
  setPrefix(){
   
    this.prefixList = this.ItemList.filter(e=> e.item_type == this.invoicedata.item);

  }
  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

 Barcodeprint(){

   let params : any = {}
   let data = this.data.invoiceList.map(item => ({ item: item.item, barcode: item.barcode }));
    data = data.flatMap(item => [item, item]);
   params['data'] = JSON.stringify(data)
 
   this.salesinvservice.bagBarcodeprint(params).then(function (res: any) { })
 }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  oncheckemptyrow(saveType){
      
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    // params["type"] = saveType;
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .savebagMasterDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            if(saveType == 'print'){
            that.Barcodeprint();
            }
            that.isShow = false;
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
          
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal("This Design" +" " + res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/bagMaster/addBagmaster.ts